import Loadable from '../../components/loadable';

const BulkUpdateFilters = Loadable({
  loader: () => import('../../pages/bulk_updates/bulk_update_filters'),
});

angular.module('gym').value('BulkUpdateFilters', BulkUpdateFilters);
